import moment from 'moment';

export function getMonths() {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
}

export function getMonthFromString(month) {
  return new Date(Date.parse(`${month} 1, 2020`)).getMonth() + 1;
}

export function getDaysPerMonth(month, year) {
  const date = new Date();
  const currentYear = date.getFullYear();

  if (month && month > 0 && month < 13 && year) {
    return Array.from(
      Array(moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()).keys(),
    );
  }

  if (month) {
    return Array.from(
      Array(moment(`${currentYear}-${month}`, 'YYYY-MM').daysInMonth()).keys(),
    );
  }

  if (year) {
    return Array.from(
      Array(moment(`${year}-01`, 'YYYY-MM').daysInMonth()).keys(),
    );
  }

  return Array.from(
    Array(moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()).keys(),
  );
}

export function getYearsTillNow() {
  return Array.from(Array(new Date().getFullYear() - 1900), (_, i) =>
    (i + 1901).toString(),
  );
}

export function calculateAge(year, month, day) {
  const birthDate = `${year}/${month}/${day}`;
  return moment().diff(birthDate, 'years', false);
}

export function calculatePersonsAge(year, month, day) {
  const date = `${year}${String(month).padStart(2, '0')}${String(day).padStart(
    2,
    '0',
  )}`;

  return moment().diff(moment(date, 'YYYYMMDD'), 'years');
}
